/* eslint class-methods-use-this: "off" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-select/async';
import autocompleteItem from 'components/snippets/autocompleteItem';
import autocompleteMenu from 'components/snippets/autocompleteMenu';
import autocompleteMenuList from 'components/snippets/autocompleteMenuList';

class FlightCarriers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cacheOptions: null,
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    componentDidMount() {
        const options = this.carrierOptions('');
        options.then((cacheOptions) => { this.setState({ cacheOptions }); });
    }

    onChange(item, action) {
        if (action.action === 'select-option' || action.action === 'remove-value' || action.action === 'clear') {
            this.props.onSelect(item);
        }
    }

    onBlur() {
        this.props.onVisibilityChange(false);
    }

    carrierOptions(filterText) {
        return new Promise((resolve) => {
            const xhr = new XMLHttpRequest();

            xhr.open('GET', `/api/autocompletes/flight-carriers/${filterText}`);

            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    const data = JSON.parse(xhr.response);
                    resolve(data);
                } else {
                    console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
                }
            };
            xhr.onerror = () => {
                console.log(`status: ${xhr.status}, statusText: ${xhr.statusText}`);
            };
            xhr.send();
        });
    }

    render() {
        const { value, placeholder, id } = this.props;
        const { cacheOptions } = this.state;

        const styles = {
            menu: () => ({}),
            menuList: () => ({}),
            option: () => ({}),
            valueContainer: (provided) => ({
                ...provided,

                margin: '0px',
                backgroundColor: '#eaecec',
                borderRadius: '8px',
            }),
            control: (provided) => ({
                ...provided,
                borderRadius: '0.3rem',
                border: '0',
            }),
            input: (provided) => ({
                ...provided,
                padding: '0px',
                margin: '0px',
                border: 0,
            }),
            dropdownIndicator: (provided) => ({
                ...provided,
                display: 'none',
            }),
            indicatorSeparator: (provided) => ({
                ...provided,
                display: 'none',
            }),
        };

        return (
            <Autocomplete
                inputId={id}
                value={value}
                placeholder={placeholder}
                styles={styles}
                components={{ Option: autocompleteItem, Menu: autocompleteMenu, MenuList: autocompleteMenuList }}
                defaultOptions={cacheOptions}
                loadOptions={this.carrierOptions}
                getOptionLabel={(option) => option.text}
                onBlur={this.onBlur}
                onChange={this.onChange}
                isMulti
            />
        );
    }
}

FlightCarriers.propTypes = {
    placeholder: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.instanceOf(Object),
};

FlightCarriers.defaultProps = {
    onVisibilityChange: () => {},
};

export default FlightCarriers;
